import type { Account } from '../../../generated-types';
import { AccountViewTypes } from '../AccountViewTypes';

const getAccountType = (account?: Account) => {
    if (!account) {
        return AccountViewTypes.NORMAL;
    }

    if ('creditLimit' in account.balance && account.balance.creditLimit) {
        return AccountViewTypes.CREDIT;
    }

    if (account.type === 'BSU') {
        return AccountViewTypes.BSU;
    }
    return AccountViewTypes.NORMAL;
};

export const getAccountViewTypeClassName = (type: AccountViewTypes) => {
    switch (type) {
        case AccountViewTypes.BSU:
        case AccountViewTypes.CREDIT:
            return 'account-with-progress-bar';
        case AccountViewTypes.NORMAL:
        default:
            return '';
    }
};

export default getAccountType;
